import { render, staticRenderFns } from "./echarts2.vue?vue&type=template&id=791e0909&"
import script from "./echarts2.vue?vue&type=script&lang=js&"
export * from "./echarts2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports